var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-alert',{staticClass:"h-full"},[_c('div',{attrs:{"slot":"description"},domProps:{"innerHTML":_vm._s(_vm.$t('forward_message_actions_alert'))},slot:"description"})])}
var staticRenderFns = []

export { render, staticRenderFns }